import React from 'react';
import PropTypes from 'prop-types';

const WrongLink = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 52.0586C24 49.8495 25.7909 48.0586 28 48.0586H100C102.209 48.0586 104 49.8495 104 52.0586V100.059C104 102.268 102.209 104.059 100 104.059H28C25.7909 104.059 24 102.268 24 100.059V52.0586Z"
      fill="#EBEEF7"
    />
    <path
      d="M24 52.0586C24 49.8495 25.7909 48.0586 28 48.0586H100C102.209 48.0586 104 49.8495 104 52.0586V100.059C104 102.268 102.209 104.059 100 104.059H28C25.7909 104.059 24 102.268 24 100.059V52.0586Z"
      fill="url(#paint0_linear_1511_14854)"
    />
    <path
      opacity="0.5"
      d="M24 52.0586C24 49.8495 25.7909 48.0586 28 48.0586H100C102.209 48.0586 104 49.8495 104 52.0586V100.059C104 102.268 102.209 104.059 100 104.059H28C25.7909 104.059 24 102.268 24 100.059V52.0586Z"
      fill="#EDE7F6"
    />
    <path
      d="M78.0451 21.3448C77.6648 20.5177 78.5186 19.6639 79.3457 20.0442L82.0756 21.2994C82.3356 21.419 82.6349 21.419 82.895 21.2994L85.6248 20.0442C86.4519 19.6639 87.3058 20.5177 86.9255 21.3448L85.6702 24.0747C85.5507 24.3347 85.5507 24.634 85.6702 24.8941L86.9255 27.6239C87.3058 28.451 86.4519 29.3049 85.6248 28.9246L82.895 27.6693C82.6349 27.5498 82.3356 27.5498 82.0756 27.6693L79.3457 28.9246C78.5186 29.3049 77.6648 28.451 78.0451 27.6239L79.3003 24.8941C79.4199 24.634 79.4199 24.3347 79.3003 24.0747L78.0451 21.3448Z"
      fill="#69F0AE"
    />
    <rect
      x="18"
      y="94.6562"
      width="8"
      height="8"
      rx="1"
      transform="rotate(-45 18 94.6562)"
      fill="#A498FF"
    />
    <path
      d="M104 52.3534C104 49.9584 102.041 47.9991 99.6457 47.9991H28.355C25.9597 47.9991 24 49.9584 24 52.3534V53.8555H104V52.3534Z"
      fill="#807DFB"
    />
    <path
      d="M37.3989 51.1391C37.3989 50.4852 37.9287 49.9559 38.5824 49.9559C39.2362 49.9559 39.766 50.4852 39.766 51.1391C39.766 51.793 39.2362 52.3223 38.5824 52.3223C37.9287 52.3223 37.3989 51.793 37.3989 51.1391Z"
      fill="white"
    />
    <path
      d="M33.0547 52.4727C32.8182 52.4727 32.7212 52.3046 32.8395 52.1L34.0483 50.0069C34.1666 49.8011 34.3604 49.8011 34.4784 50.0069L35.6873 52.1C35.8055 52.3046 35.7089 52.4727 35.4724 52.4727H33.0547"
      fill="white"
    />
    <path
      d="M28.4824 50.3137C28.4824 50.1171 28.6437 49.9559 28.8409 49.9559H30.4909C30.6881 49.9559 30.8494 50.1171 30.8494 50.3137V51.9644C30.8494 52.1611 30.6881 52.3223 30.4909 52.3223H28.8409C28.6437 52.3223 28.4824 52.1611 28.4824 51.9644V50.3137Z"
      fill="white"
    />
    <path
      d="M92.5687 51.7735C92.5687 52.2524 92.1777 52.6445 91.6987 52.6445H44.0484C43.5693 52.6445 43.1772 52.2524 43.1772 51.7735V50.0816C43.1772 49.6026 43.5693 49.2105 44.0484 49.2105H91.6987C92.1777 49.2105 92.5687 49.6026 92.5687 50.0816V51.7735"
      fill="#9F9CFF"
    />
    <path
      d="M96.3512 28.4517C96.5741 27.8494 97.4259 27.8494 97.6488 28.4517L99.1318 32.4595C99.2019 32.6488 99.3512 32.7981 99.5405 32.8682L103.548 34.3512C104.151 34.5741 104.151 35.4259 103.548 35.6488L99.5405 37.1318C99.3512 37.2019 99.2019 37.3512 99.1318 37.5405L97.6488 41.5483C97.4259 42.1506 96.5741 42.1506 96.3512 41.5483L94.8682 37.5405C94.7981 37.3512 94.6488 37.2019 94.4595 37.1318L90.4517 35.6488C89.8494 35.4259 89.8494 34.5741 90.4517 34.3512L94.4595 32.8682C94.6488 32.7981 94.7981 32.6488 94.8682 32.4595L96.3512 28.4517Z"
      fill="#6554E7"
    />
    <path
      d="M85.4416 89.3125H71.8632C65.4363 89.3125 60.2075 84.0837 60.2075 77.6568H64.7802C64.7802 81.563 67.957 84.7399 71.8632 84.7399H85.4416C89.3466 84.7399 92.5246 81.563 92.5246 77.6568C92.5246 73.7518 89.3466 70.5738 85.4416 70.5738H71.8632V66.0012H85.4416C91.8684 66.0012 97.0973 71.23 97.0973 77.6568C97.0973 84.0837 91.8684 89.3125 85.4416 89.3125Z"
      fill="#807DFB"
    />
    <path
      d="M54.2959 96.6865L47.5066 96.679C41.0798 96.6718 35.8569 91.4372 35.864 85.0104C35.8658 83.4042 36.1941 81.8728 36.7862 80.4799C37.4753 80.0794 38.1872 79.6687 38.9244 79.2511C38.7138 78.9708 38.4394 78.5281 38.1708 78.0705C40.3002 75.2138 43.7047 73.3634 47.5325 73.3677L54.3218 73.3752L54.3167 77.9478L47.5274 77.9403C43.6219 77.936 40.441 81.1104 40.4366 85.0154C40.4323 88.9216 43.6062 92.102 47.5117 92.1063L54.301 92.1139L54.2959 96.6865"
      fill="#D5DAF4"
    />
    <path
      d="M59.6257 89.3125H52.8364V84.7399H59.6257C63.5307 84.7399 66.7087 81.563 66.7087 77.6568C66.7087 73.7518 63.5307 70.5738 59.6257 70.5738H52.8364V66.0012H59.6257C66.0525 66.0012 71.2813 71.23 71.2813 77.6568C71.2813 84.0837 66.0525 89.3125 59.6257 89.3125Z"
      fill="#A498FF"
    />
    <path
      d="M51.4862 94.8751L44.6996 94.6809C38.2754 94.4972 33.1983 89.121 33.3821 82.6968C33.5659 76.2726 38.9419 71.1954 45.3662 71.3792L52.1527 71.5733L52.022 76.1441L45.2354 75.9499C41.3315 75.8383 38.0645 78.9241 37.9529 82.8275C37.8412 86.7321 40.9265 89.9985 44.8303 90.1102L51.6169 90.3043L51.4862 94.8751Z"
      fill="#A498FF"
    />
    <path
      d="M64.7802 77.6562H60.2075C60.2075 71.2294 65.4363 66.0006 71.8632 66.0006V70.5732C67.957 70.5732 64.7802 73.7512 64.7802 77.6562Z"
      fill="#807DFB"
    />
    <path
      d="M75.1959 60.9434C74.1294 60.9434 73.1268 60.5284 72.3735 59.7739C71.1492 58.553 69.1601 58.553 67.938 59.7751C66.3788 61.3309 63.8455 61.3309 62.2897 59.7751C61.6975 59.1829 60.9099 58.8571 60.072 58.8571C59.2329 58.8571 58.4464 59.1829 57.8554 59.7739C57.1009 60.5284 56.0983 60.9434 55.0318 60.9434C53.9652 60.9434 52.9626 60.5284 52.2082 59.7739C50.985 58.553 48.9947 58.553 47.7738 59.7751C46.2157 61.3309 43.682 61.3309 42.1256 59.7751C41.9581 59.607 41.9581 59.3361 42.1256 59.168C42.293 59.0011 42.5644 59.0011 42.7318 59.168C43.9542 60.3901 45.9442 60.3901 47.1679 59.168C48.7227 57.6133 51.2559 57.6122 52.8152 59.168C53.4062 59.7602 54.1938 60.086 55.0318 60.086C55.8686 60.086 56.6562 59.7602 57.2483 59.168C58.0017 58.4147 59.0042 57.9997 60.072 57.9997C61.1385 57.9997 62.1422 58.4147 62.8956 59.168C64.1176 60.3901 66.1078 60.3901 67.3322 59.168C68.8868 57.6122 71.4212 57.6122 72.9794 59.168C73.5715 59.7602 74.358 60.086 75.1959 60.086C76.0339 60.086 76.8215 59.7602 77.4125 59.168C78.1659 58.4147 79.1684 57.9997 80.2361 57.9997C81.3027 57.9997 82.3053 58.4147 83.0586 59.168C83.2255 59.3361 83.2255 59.607 83.0586 59.7751C82.8905 59.942 82.6196 59.942 82.4527 59.7751C81.8606 59.1829 81.0741 58.8571 80.2361 58.8571C79.3982 58.8571 78.6106 59.1829 78.0196 59.7751C77.2651 60.5284 76.2625 60.9434 75.1959 60.9434Z"
      fill="#DCD6F1"
    />
  </svg>
);

WrongLink.propTypes = {
  size: PropTypes.number,
};

WrongLink.defaultProps = {
  size: 128,
};

export default WrongLink;
